// eslint-disable-next-line no-restricted-imports
import styled from '@emotion/styled';
import { Box, Flex } from '@iheartjane/reefer';
import type { PriceId } from '@iheartjane/types';

import type { WeightSelectorWeight } from '@jane/shared-ecomm/types';
// eslint-disable-next-line no-restricted-imports
import type { MenuProduct } from '@jane/shared/models';

import SvgIcon from '../../legacyIcons/legacySvgIcon';
import { VariantSelectionButton } from './variantSelectionButton';

export const CheckIconWrapper = styled.span(
  {
    position: 'absolute',
    top: -4,
    right: -3,
    zIndex: 'var(--layers-visible)',
    svg: {
      background: 'white',
      opacity: 1,
      border: '1px solid inherit',
      borderRadius: '50%',
    },
  },
  ({ theme }) => [
    { color: theme ? theme.colors.primary.main : 'rgba(255, 255, 255, 1)' },
  ]
);

export const StyledGrid = styled(Box)({
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(155px, 1fr))',
  gap: 8,
  width: '100%',
  justifyItems: 'stretch',
  justifyContent: 'flex-end',
});

interface WeightItemsProps {
  cartWeights?: PriceId[];
  editingMode: boolean;
  menuProduct: MenuProduct;
  onChange: (priceId: PriceId) => void;
  selectedWeight: PriceId | null;
  weights: WeightSelectorWeight[];
}

const WeightItems = ({
  weights,
  selectedWeight,
  onChange,
  menuProduct,
  cartWeights,
}: WeightItemsProps) => {
  const menuProductWeightValues = weights.map((weight) => weight.value);

  return (
    <StyledGrid>
      {menuProductWeightValues.map((weight) => {
        return (
          <Flex
            position="relative"
            key={weight}
            width="100%"
            justifyContent="flex-end"
          >
            <VariantSelectionButton
              key={`${menuProduct.id}-${weight}`}
              onChange={() => onChange(weight)}
              selected={weight === selectedWeight}
              weight={weight}
            />
            {cartWeights?.includes(weight) && (
              <CheckIconWrapper>
                <SvgIcon size={18} icon="circleCheckFilled" />
              </CheckIconWrapper>
            )}
          </Flex>
        );
      })}
    </StyledGrid>
  );
};

export default WeightItems;
